/*
    AnalyticsPlugin
    * analytics options on vue instance can be an object or function

     examples:
        analytics: {
         'feature:event': 'some event'
        }

        **OR**

        analytics: {
         'feature:event': {
            msg: 'some event',
          }
        }

       **OR**

        analytics() {
           return {
            'feature:event': this.prop + 'event'
           };
        }

 */
import Analytics from 'c/WtAnalytics';

const AnalyticsPlugin = {};

function hasEvent(eventName) {
  const events = Analytics._events;
  return !_.isEmpty(events && events[eventName]);
}

function loopAnalytics(analytics, onEventLoop, ctx) {
  if (_.isEmpty(analytics)) {
    return;
  }
  const isFn = _.isFunction(analytics);
  const isObject = _.isPlainObject(analytics);

  if (!isFn && !isObject) {
    console.error(
      `AnalyticsPlugin: analytics must be object or function! 
                 analytics: ${JSON.stringify(analytics, null, 2)}`
    );
    return;
  }

  const obj = isFn ? analytics.call(ctx) : analytics;

  Object.keys(obj).forEach((key) => {
    const eventName = 'p-analytics:' + key;
    const eventVal = obj[key];
    const options = Object.assign(
      {
        name: eventName,
        msg: '',
        existed: false,
      },
      _.isPlainObject(eventVal) ? eventVal : { msg: eventVal }
    );

    if (hasEvent(options.name)) {
      options.existed = true;
    }

    _.isFunction(onEventLoop) && onEventLoop(options);
  });
}

AnalyticsPlugin.install = function (Vue /* , options */) {
  Vue.mixin({
    beforeCreate() {
      const analytics = this.$options.analytics;

      if (!analytics) {
        return;
      }

      loopAnalytics(
        analytics,
        (event) => {
          if (!this.__analytics_track) {
            this.__analytics_track = {};
          }

          const fn = Analytics.$track(event.msg);
          this.__analytics_track[event.name] = fn;
          Analytics.on(event.name, fn);
        },
        this
      );
    },

    destroyed() {
      const analytics = this.$options.analytics;

      if (!analytics) {
        return;
      }

      loopAnalytics(
        analytics,
        (event) => {
          Analytics.off(event.name, this.__analytics_track[event.name]);
        },
        this
      );
    },
  });

  Vue.prototype.$triggerAnalytics = function (name, options) {
    Analytics.trigger('p-analytics:' + name, options);
  };
};

export default AnalyticsPlugin;
